module.exports = __webpack_public_path__ + "static/media/express-dark.ab0017ae.png";